module.exports = __webpack_public_path__ + "front/img/27_4.163a0abb.png";